import { PersonalDetailsInput, UserService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type MutationVariables = {
  uid: string;
  requestBody: PersonalDetailsInput;
};

export const useSendPersonalDetailsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof UserService.putUsersPersonalDetails1>>,
      QueryError,
      MutationVariables,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(({ uid, requestBody }: MutationVariables) => UserService.putUsersPersonalDetails1(uid, requestBody), {
    ...options,
    onSuccess: () => {
      toast.success('Successfully updated!');
    },
    onError: (error: QueryError) => {
      const message = formatErrorMessage(error);
      toast.error(message);
      console.error(message);
    }
  });
